import React, {
  FC,
  memo,
  useCallback,
  useState,
}                                from 'react';
import { History }               from 'history';
import { GridSpacing }           from '@material-ui/core';
import { Breakpoint }            from '@material-ui/core/styles/createBreakpoints';
import { ICardAd }               from '@typings/nationalAdManagement';
import { EAppPage }              from '@enums/common';
import {
  ENationalAdPage,
  ENationalAdSubpage,
}                                from '@enums/nationalAdManagement';
import {
  useFetchCardAds,
  useRemoveCardAd,
}                                from '@modules/nationalAdManager/queries/nationalAdQueries';
import { AdsListWrapper }        from '@modules/nationalAdManager/components/AdsListWrapper';
import { AdDeleteConfirmDialog } from '@modules/nationalAdManager/components/AdDeleteConfirmDialog';

const spacings: Map<Breakpoint, GridSpacing> = new Map([
  ['xs', 3],
  ['sm', 2],
  ['md', 3],
  ['lg', 4],
  ['xl', 5],
]);

interface IProps extends Pick<History, 'push'>{
  width: Breakpoint;
}

const AdsList: FC<IProps> = ({ width, push }) => {
  const [adsData, setAdsData] = useState<ICardAd[]>([]);
  const [deletedAdId, setDeletedAdId] = useState<string>('');

  // #region api integration
  useFetchCardAds({
    onSuccess: (data) => setAdsData(data),
  });

  const { mutateAsync: removeAd, isLoading: isAdRemoving } = useRemoveCardAd({
    onSuccess: () => {
      setAdsData((prev) => prev.filter((cardAd) => cardAd.id !== deletedAdId));
      setDeletedAdId('');
    },
  });
  // #endregion

  const onEditAd = useCallback(
    (adId: string): void => {
      push(`${EAppPage.NationalAdManager}/${ENationalAdPage.cards}/${adId}/${ENationalAdSubpage.edit}`);
    },
    [push],
  );

  return (
    <>
      <AdsListWrapper
        adsData    = {adsData}
        spacing    = {spacings.get(width) ?? 0}
        onEditAd   = {onEditAd}
        onDeleteAd = {(adId) => setDeletedAdId(adId)}
      />

      <AdDeleteConfirmDialog
        width        = {width}
        onCancel     = {() => setDeletedAdId('')}
        onConfirm    = {() => removeAd(deletedAdId)}
        isOpen       = {!!deletedAdId}
        isAdRemoving = {isAdRemoving}
      />
    </>
  );
};

export const AdsListContainer = memo(AdsList);
